import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Icon } from './ui/Icons';
import { getCoursePath } from '../data/courses';

export default function CourseCard({ title, duration, price, features, img, badge, highlight, slug }) {
  const coursePath = getCoursePath({ title, slug });

  return (
    <motion.article
      className="course-card"
      whileHover={{ y: -8 }}
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="course-card__img-wrap">
        <img src={img} alt={title} className="course-card__img" loading="lazy" onError={e => { e.target.style.opacity = '0.3'; }} />
        <div className="course-card__overlay" />
        <span className="course-card__duration">
          <Icon name="clock" size={14} /> {duration}
        </span>
        {badge && <span className="badge badge--accent" style={{ position: 'absolute', top: 14, right: 14 }}>{badge}</span>}
        {highlight && <span className="badge" style={{ position: 'absolute', top: 14, left: 14, background: 'rgba(251, 191, 36, 0.2)', color: '#fbbf24', border: '1px solid rgba(251,191,36,0.4)' }}>Special</span>}
      </div>
      <div className="course-card__body">
        <h3 className="course-card__title">
          <Link to={coursePath}>{title}</Link>
        </h3>
        {features && (
          <ul className="course-card__features">
            {features.map(f => (
              <li key={f}>
                <span className="course-card__check"><Icon name="check" size={10} /></span>
                {f}
              </li>
            ))}
          </ul>
        )}
        <div className="course-card__footer">
          {price && <div className="course-card__price">{price}</div>}
          <Link to={coursePath} className="btn-lux btn-lux--fill" style={{ width: '100%', justifyContent: 'center', fontSize: 11, padding: '12px 16px', color: '#030712' }}>
            Course Details
            <Icon name="arrowRight" size={16} />
          </Link>
        </div>
      </div>
    </motion.article>
  );
}
